import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import getRenderable from '../../../../lib/getRenderable';
import { SIZES } from '../constants';
import { BASE_CLASSES, OFFSET_CLASS } from './constants';

const Col = ({
    children,
    className,
    xs,
    xsOffset,
    sm,
    smOffset,
    md,
    mdOffset,
    lg,
    lgOffset,
    xl,
    xlOffset
}) => {

    const classes = classnames(
        className,
        {
            [`${BASE_CLASSES}-${SIZES.xs}-${xs}`]: xs,
            [`${BASE_CLASSES}-${SIZES.sm}-${sm}`]: sm,
            [`${BASE_CLASSES}-${SIZES.md}-${md}`]: md,
            [`${BASE_CLASSES}-${SIZES.lg}-${lg}`]: lg,
            [`${BASE_CLASSES}-${SIZES.xl}-${xl}`]: xl,
            [`${OFFSET_CLASS}-${SIZES.xs}-${xsOffset}`]: xsOffset,
            [`${OFFSET_CLASS}-${SIZES.sm}-${smOffset}`]: smOffset,
            [`${OFFSET_CLASS}-${SIZES.md}-${mdOffset}`]: mdOffset,
            [`${OFFSET_CLASS}-${SIZES.lg}-${lgOffset}`]: lgOffset,
            [`${OFFSET_CLASS}-${SIZES.xl}-${xlOffset}`]: xlOffset
        }
    );

    return (
        <div className={classes}>
            { getRenderable(children) }
        </div>
    );
};

Col.propTypes = {
    /**
     * Any node that can be rendered.
     */
    children: PropTypes.node,
    /**
     * Custom classes to pass to the component.
     */
    className: PropTypes.string,
    /**
     * Number of grid columns occupied within the xs breakpoint.
     */
    xs: PropTypes.number,
    /**
     * Number of grid columns offset within the xs breakpoint.
     */
    xsOffset: PropTypes.number,
    /**
     * Number of grid columns occupied within the sm breakpoint.
     */
    sm: PropTypes.number,
    /**
     * Number of grid columns offset within the sm breakpoint.
     */
    smOffset: PropTypes.number,
    /**
     * Number of grid columns occupied within the md breakpoint.
     */
    md: PropTypes.number,
    /**
     * Number of grid columns offset within the md breakpoint.
     */
    mdOffset: PropTypes.number,
    /**
     * Number of grid columns occupied within the lg breakpoint.
     */
    lg: PropTypes.number,
    /**
     * Number of grid columns offset within the lg breakpoint.
     */
    lgOffset: PropTypes.number,
    /**
     * Number of grid columns occupied within the xl breakpoint.
     */
    xl: PropTypes.number,
    /**
     * Number of grid columns offset within the xl breakpoint.
     */
    xlOffset: PropTypes.number
};

export default Col;
